import { render, staticRenderFns } from "./RegisterMembership.vue?vue&type=template&id=1040f4a4&scoped=true&"
import script from "./RegisterMembership.vue?vue&type=script&lang=js&"
export * from "./RegisterMembership.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMembership.vue?vue&type=style&index=0&id=1040f4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040f4a4",
  null
  
)

export default component.exports